import { CrmChangelogConfig } from 'common-module/changelog';

export const changelogConfig: CrmChangelogConfig = {
  changelogModal: true,
  changelogStatic: true,
  changelogStaticPath: '/assets/fixtures/content/changelog.json'
};
